import styles from './formSeparator.module.css'

type Props = {
    title: string
    className?: string
}

export const FormSeparator = (props: Props) => {
    const { title, className } = props

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <span>{title}</span>
            <div className={styles.separator} />
        </div>
    )
}
